import { render } from "./PublicStatus.vue?vue&type=template&id=661155a4&scoped=true"
import script from "./PublicStatus.vue?vue&type=script&lang=js"
export * from "./PublicStatus.vue?vue&type=script&lang=js"

import "./PublicStatus.vue?vue&type=style&index=0&id=661155a4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-661155a4"

export default script